export default __webpack_public_path__ + "c7a2369ffe7bc7dec895f22300ebf738.png";